import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'

import { SET_END_USER_FILTER, urgentUnclassifiedIncidentsRedux } from './redux'

const initialState = {
  data: [],
  loader: false,
  error: null,
  endUserFilter: false,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case COMPANY_FILTER_CHANGE:
    case urgentUnclassifiedIncidentsRedux.INITIATE:
      return { ...state, loader: true }
    case urgentUnclassifiedIncidentsRedux.SUCCESS: {
      return {
        ...state,
        data: action.payload,
        error: null,
        loader: false,
      }
    }
    case urgentUnclassifiedIncidentsRedux.ERROR:
      return { ...state, error: action.error, loader: false }
    case urgentUnclassifiedIncidentsRedux.CANCEL:
      return { ...state, loader: false }
    case SET_END_USER_FILTER: {
      return { ...state, endUserFilter: action.payload, loader: true }
    }
    default:
      return state
  }
}
